/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateRackShelfRequest } from './create-rack-shelf-request';


export interface CreateRackRequest { 
    containerId: string;
    number: number;
    description?: string | null;
    socketTypeId: number;
    subnet: string;
    shelves?: Array<CreateRackShelfRequest> | null;
}

